import isNil from './is-nil';
export default (function (value) {
  if (isNil(value)) return '';
  return value.toString();
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/to-string.js
// module id = 10
// module chunks = 0